declare namespace $ {

	type $mol_view__style_bog_gamengine_input_screen_1 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $bog_gamengine_input_screen['knob_shift'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__event_bog_gamengine_input_screen_2 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_gamengine_input_screen['stick_down'] > ): ReturnType< $bog_gamengine_input_screen['stick_down'] >,
			pointermove( next?: ReturnType< $bog_gamengine_input_screen['stick_move'] > ): ReturnType< $bog_gamengine_input_screen['stick_move'] >,
			pointerup( next?: ReturnType< $bog_gamengine_input_screen['stick_up'] > ): ReturnType< $bog_gamengine_input_screen['stick_up'] >,
			pointercancel( next?: ReturnType< $bog_gamengine_input_screen['stick_cancel'] > ): ReturnType< $bog_gamengine_input_screen['stick_cancel'] >,
			pointerleave( next?: ReturnType< $bog_gamengine_input_screen['stick_leave'] > ): ReturnType< $bog_gamengine_input_screen['stick_leave'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_gamengine_input_screen_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_input_screen_4 = $mol_type_enforce<
		ReturnType< $bog_gamengine_input_screen['buttons'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button__title_bog_gamengine_input_screen_5 = $mol_type_enforce<
		ReturnType< $bog_gamengine_input_screen['button_title'] >
		,
		ReturnType< $mol_button['title'] >
	>
	type $mol_button__event_bog_gamengine_input_screen_6 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_gamengine_input_screen['button_down'] > ): ReturnType< $bog_gamengine_input_screen['button_down'] >,
			pointerup( next?: ReturnType< $bog_gamengine_input_screen['button_up'] > ): ReturnType< $bog_gamengine_input_screen['button_up'] >,
			pointercancel( next?: ReturnType< $bog_gamengine_input_screen['button_cancel'] > ): ReturnType< $bog_gamengine_input_screen['button_cancel'] >,
			pointerleave( next?: ReturnType< $bog_gamengine_input_screen['button_leave'] > ): ReturnType< $bog_gamengine_input_screen['button_leave'] >,
		})  & ReturnType< $mol_button['event'] >
		,
		ReturnType< $mol_button['event'] >
	>
	export class $bog_gamengine_input_screen extends $mol_view {
		stick_down( next?: any ): any
		stick_move( next?: any ): any
		stick_up( next?: any ): any
		stick_cancel( next?: any ): any
		stick_leave( next?: any ): any
		Knob( ): $mol_view
		Stick( ): $mol_view
		buttons( ): readonly(any)[]
		Buttons( ): $mol_view
		button_title( id: any): string
		button_down( id: any, next?: any ): any
		button_up( id: any, next?: any ): any
		button_cancel( id: any, next?: any ): any
		button_leave( id: any, next?: any ): any
		shown( next?: boolean ): boolean
		actions( ): readonly(string)[]
		titles( ): Record<string, any>
		bind( ): Record<string, any>
		dead( ): number
		radius( ): number
		knob_shift( next?: string ): string
		sub( ): readonly(any)[]
		Button( id: any): $mol_button
	}
	
}

//# sourceMappingURL=screen.view.tree.d.ts.map